<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('customerProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('customerProfile.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div
            class="ts-flex ts-space-x-3"
          >
            <ts-button outline color="info" @click.prevent="addNew">{{
              $t('add_new')
            }}</ts-button>
            <ts-button
              :waiting="waiting"
              outline
              @click.prevent="approveCustomer"
            >
              {{ $t('customerProfile.approved') }}
            </ts-button>
            <Dropdown trigger="click" class="ml-2" @on-click="onClickExport">
              <ts-button color="success" :waiting="exporting">
                <i class="fas fa-file-excel"></i>
                {{ $t('customerProfile.exportExcel') }}
                <Icon type="ios-arrow-down"></Icon>
              </ts-button>
              <template #list>
                <DropdownMenu>
                  <DropdownItem :name="1" :disabled="!checkedItems.length > 0">
                    <i class="fas fa-check-square"></i>
                    {{ $t('customerProfile.selectedCustomer') }}
                  </DropdownItem>
                  <DropdownItem :name="2">
                    <i class="fas fa-users"></i>
                    {{ $t('customerProfile.allCustomer') }}
                  </DropdownItem>
                </DropdownMenu>
              </template>
            </Dropdown>
          </div>
          <div class="d-flex ts-space-x-3">
            <a-radio-group v-model="approveStatus" @change="fetchData()">
              <a-radio-button :value="undefined">
                {{ $t('all') }}
              </a-radio-button>
              <a-radio-button :value="0">
                {{ $t('customerProfile.pending') }}
                <span class="badge badge-danger">{{ pendingCount }}</span>
              </a-radio-button>
              <a-radio-button :value="2">
                {{ $t('customerProfile.approved') }}
              </a-radio-button>
            </a-radio-group>
            <ts-input
              v-model="search"
              v-tooltip="$t('customerProfile.search')"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row ts-mb-3">
                <div class="col-md-12">
                  <label class="">{{ $t('customerProfile.branchName') }}</label>
                  <a-select
                    style="width: 257px"
                    v-model="branch_id"
                    :options="branchs"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                    @change="changeBranch()"
                  >
                  </a-select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{
                    $t('customerProfile.warehourseName')
                  }}</label>
                  <a-select
                    style="width: 257px"
                    v-model="location_id"
                    :options="locations"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                  >
                  </a-select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="ts-mt-2">{{
                    $t('customerProfile.sale')
                  }}</label>
                  <a-select
                    style="width: 257px"
                    v-model="sale_id"
                    :options="sales"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                  >
                  </a-select>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :showCheckbox="true"
          checkBoxValueField="customer_id"
          @check-items="v => (checkedItems = v)"
          ref="tableCustomer"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch.branch_name_en }}
            </td>
            <td>{{ record.customer_code }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.customer_name }}</td>
            <td>{{ record.gender }}</td>
            <td>{{ record.contact_number }}</td>
            <td>{{ record.ss_id_card }}</td>
            <td>{{ record.contact_email }}</td>
            <td>{{ record.type.customer_type }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.sale ? record.sale.employee_name_en : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.dealer_type }}</td>
            <td class="ts-text-center">{{ record.dealer_grade }}</td>
            <!-- <td>{{ record.account_number }}</td> -->
            <td class="ts-text-center">
              <span
                class="badge badge-success"
                v-if="record.is_general_customer"
                >Yes</span
              >
              <span class="badge badge-danger" v-else>No</span>
            </td>
            <td class="ts-text-center">
              <span class="badge badge-success" v-if="record.is_membership"
                >Yes</span
              >
              <span class="badge badge-danger" v-else>No</span>
            </td>
            <td class="ts-text-center">
              <span class="badge badge-danger" v-if="record.approve_status == 0"
                >Pending</span
              >
              <span
                class="badge badge-success"
                v-if="record.approve_status == 1"
                >Partially Approved</span
              >
              <span
                class="badge badge-success"
                v-if="record.approve_status == 2"
                >Approved</span
              >
              <span class="badge badge-info" v-if="record.approve_status == 3"
                >Rejected</span
              >
            </td>
            <td class="ts-text-right">
              {{ record.membership_discount_rate }}
            </td>
            <td class="ts-text-center ts-whitespace-no-wrap">
              {{ record.user ? record.user.name : '' }}
            </td>
            <td class="text-center ts-space-x-3">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('customerProfile.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="60%"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import { mapState, mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'
import FromAction from './form1.vue'

export default {
  name: 'customerProfileIndex',
  components: {
    FromAction,
  },
  data() {
    return {
      waiting: false,
      loading: false,
      exporting: false,
      errors: new Errors(),
      showForm: false,
      branchs: [],
      locations: [],
      checkedItems: [],
      sales: []
    }
  },
  computed: {
    ...mapState('customer/profile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.customer.profile.search
      },
      set(newValue) {
        this.$store.commit('customer/profile/SET_SEARCH', newValue)
        this.$store.commit('customer/profile/RESET_CURRENT_PAGE')
      },
    },
    approveStatus: {
      get() {
        return this.$store.state.customer.profile.approve_status
      },
      set(newValue) {
        this.$store.commit('customer/profile/SET_APPROVED_STATUS', newValue)
      },
    },
    location_id: {
      get() {
        return this.$store.state.customer.profile.location_id
      },
      set(newValue) {
        this.$store.commit('customer/profile/SET_LOCATION_ID', newValue)
      }
    },
    branch_id: {
      get() {
        return this.$store.state.customer.profile.branch_id
      },
      set(newValue) {
        this.$store.commit('customer/profile/SET_BRANCH_ID', newValue)
      }
    },
    sale_id: {
      get() {
        return this.$store.state.customer.profile.sale_id
      },
      set(newValue) {
        this.$store.commit('customer/profile/SET_SALE_ID', newValue)
      }
    },
    pendingCount() {
      return this.resources.filter(r => r.approve_status == 0).length
    },
    columns() {
      return [
        { name: this.$t('customerProfile.branchName') },
        { name: this.$t('customerProfile.customerCode') },
        { name: this.$t('customerProfile.customerName') },
        { name: this.$t('customerProfile.gender') },
        { name: this.$t('customerProfile.phoneNumber') },
        { name: this.$t('customerProfile.idCard') },
        { name: this.$t('customerProfile.email') },
        { name: this.$t('customerProfile.customerType') },
        { name: this.$t('customerProfile.sale') },
        { name: this.$t('customerProfile.dealerType') },
        { name: this.$t('customerProfile.grade') },
        // { name: this.$t('customerProfile.accountNumber') },
        {
          name: this.$t('customerProfile.isGeneralCustomer'),
          style: 'text-align:center',
        },
        {
          name: this.$t('customerProfile.isMembership'),
          style: 'text-align:center',
        },
        { name: this.$t('customerProfile.status'), style: 'text-align:center' },
        {
          name: this.$t('customerProfile.discountRate'),
          style: 'text-align:right',
        },
        {
          name: this.$t('customerProfile.createdBy'),
          style: 'text-align:center'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.user.default_branch.branch_id]
    this.getBranch()
    this.getSaleList()
    this.changeBranch()
    // this.location_id = [
    // this.$store.state.authUser.user.default_location.location_id
    // ]
  },
  methods: {
    ...mapActions('report/resource', ['getLocation', 'getFormViewModel']),
    ...mapActions('customer/profile', ['getFormViewModel']),
    getSaleList() {
      this.getFormViewModel({
        fnName: 'sale'
      }).then(response => {
        this.sales = response.data.sale
      })
    },
    onClickExport(type) {
      if (type == 1) {
        this.exportExcel(this.checkedItems)
      }
      if (type == 2) {
        this.exportExcel()
      }
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('customer/profile/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.$router.push({ name: 'customer-profile-create' })
      // this.showForm = true
    },
    edit(record) {
      this.$store.commit('customer/profile/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'customer-profile-edit',
        params: { id: record.customer_id },
      })
      // this.showForm = true
    },
    clearEdit() {
      this.$store.commit('customer/profile/SET_EDIT_DATA', {})
      this.showForm = false
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('customer/profile/destroy', record.customer_id)
        .then((response) => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    getBranch() {
      this.loading = true
      this.$store
        .dispatch('security/user/getBranchAssignedForFilter')
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async changeBranch() {
      this.loading = true
      this.location_id = []
      await this.$store
        .dispatch('security/user/getWarehouseAssignedForFilter', {
          branch_id: this.branch_id
        })
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    exportExcel(checkedItems = []) {
      this.errors = new Errors()
      this.exporting = true

      this.$store
        .dispatch('customer/profile/customerExportExcel', {
          customer_id: checkedItems
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.notice({ type: 'error', text: error.message })
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    approveCustomer() {
      if (!this.checkedItems.length) {
        this.$toasted.error('Please select any dealers.')
        return
      }
      this.waiting = true
      this.$store
        .dispatch('customer/profile/approveMulti', {
          customer_id: this.checkedItems
        })
        .then((response) => {
          this.$toasted.success(response.message)
          this.$refs.tableCustomer.checkedItems = []
          this.checkedItems = []
          this.fetchData()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    notice(not) {
      this.$Notice[not.type]({
        title: 'PROFILE',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500),
    location_id: debounce(function() {
      this.fetchData(this.search)
    }, 500),
    sale_id: debounce(function() {
      this.fetchData(this.search)
    }, 500),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('customer/profile/RESET_STATE')
    this.$store.commit('customer/profile/CLEAR_STATE')
    next()
  },
}
</script>
